import { TAG_VARIANT, TagVariant } from './Tag.types';

interface VariantConditions {
  danger?: boolean;
  alert?: boolean;
  success?: boolean;
  primary?: boolean;
  secondary?: boolean;
  neutral?: boolean;
  gold?: boolean;
}

export const getTagVariant = (conditions: VariantConditions): TagVariant => {
  if (conditions.danger) {
    return TAG_VARIANT.DANGER;
  }
  if (conditions.alert) {
    return TAG_VARIANT.ALERT;
  }
  if (conditions.success) {
    return TAG_VARIANT.SUCCESS;
  }
  if (conditions.primary) {
    return TAG_VARIANT.PRIMARY;
  }
  if (conditions.secondary) {
    return TAG_VARIANT.SECONDARY;
  }
  if (conditions.neutral) {
    return TAG_VARIANT.NEUTRAL;
  }
  if (conditions.gold) {
    return TAG_VARIANT.GOLD;
  }

  return TAG_VARIANT.DEFAULT;
};
